<template>
  <div>
    <div :class="[{'content-box': !disableCard}, { 'no-card': disableCard, 'loading-size': true }]">
      <div class="m-2 text-center" v-show="isLoading">
        <font-awesome-icon
          :icon="['fa', 'circle-notch']"
          class="fa-spin m-auto spinner fa-5x egx-partner-color"
        />
      </div>
      <div :class="['card-body', { 'no-card': disableCard }]" v-if="!isLoading">
        <div v-html="stepConfiguration?.portaltandcconfig?.terms_and_conditions" />
        <div class="mt-3">
          <div>
            <input type="checkbox" v-model="acceptTerms" id="terms-and-conditions" required/>
            <label class="ml-2" for="terms-and-conditions">{{stepConfiguration.portaltandcconfig?.accept_check_box_label}}</label>
          </div>
          <span v-if="error && !acceptTerms" class="text-danger">You must accept the terms and conditions</span>
        </div>
      </div>
    </div>
    <step-button
      :steps-response="stepsResponse"
      @navigate="navigate"
      @save-data="saveData"
      :data-save-required="true"
    />
  </div>
</template>
<script>
import StepButton from '@/components/project/stepButton.vue';
export default {
  name: 'TermsAndConditions',

  components: {
    StepButton,
  },
  
  data() {
    return {
      isVisible: false,
      disableCard: false,
      isLoading: false,
      acceptTerms: this.stepConfiguration?.portaltandcconfig?.accept_tnc || false,
      error: false,
    };
  },

  props: {
    content: Object,
    stepsResponse: Object,
    navigate: Function,
    projectId: String,
    projectStatus: String,
    fulfillSyncDetails: Object,
    stepConfiguration: Object,

  },

  methods: {
    saveData(step) {
      if (!this.acceptTerms) {
        this.error = true;
        return;
      }
      const data = {
        accept_tnc: this.acceptTerms,
        is_tc_update: true,
        details: { isFieldUpdate: false, project_id: this.$route.params.id }
      }
      if (this.stepConfiguration.portaltandcconfig.accept_status_value) {
        data.project_status = this.stepConfiguration.portaltandcconfig.accept_status_value;
      }

      this.$store.dispatch('fulfill_integrate/post', data).then(() => {
        this.$notify({
          group: 'notice',
          text: this.stepConfiguration?.portaltandcconfig?.confirmation_message || this.fulfillSyncDetails.messages?.project_tc_update?.success,
          duration: 5000,
        });

        if (step === 'nextStep') {
          this.navigate();
        } else if (step === 'linkStep') {
          this.redirectPath(this.stepsResponse.add_btn_url);
        } else if (step === 'saveChanges') {
          this.redirectPath(this.saveChangesButton?.url || '/applications');
        }
      }).catch((error) => {
        console.log(error.message);
        this.isLoading = false;
        this.$notify({
          group: 'notice',
          text: error.message,
        });
      })
    }
  }
};
</script>
<style>
.loading-size {
  min-width: 60rem;
}
</style>